import type { CartRecommendationItem } from '@diamond/shared/types';

import type { EcommerceItem } from './build-ecommerce-items';

/**
 * Maps cart recommendation items into the GA4 ecommerce item shape.
 *
 * The existing `buildEcommerceItems` expects `Cart[]` rows and is not
 * compatible with the nested `{ product, recommendation }` recommendation
 * shape, so recommendation tracking uses this dedicated adapter. The list is
 * always tagged with `item_list_id = 'cart_recommendation'` and the caller's
 * `itemListName` so placements can be distinguished in GA4.
 */
export const buildRecommendationEcommerceItems = (
  items: CartRecommendationItem[],
  itemListName: string
): EcommerceItem[] => {
  return items.map((item, index) => ({
    id: item.product.id,
    item_id: item.product.item_code?.toString(),
    item_name: item.product.title,
    item_brand: item.product.brand_name,
    affiliation: item.product.brand_desc,
    coupon: item.product.discount_promos?.[0]?.promo_code || '',
    discount: item.product.discount_promos?.[0]?.deduction_amount || 0,
    index: item.recommendation.rank ?? index,
    item_category: item.product.category_name,
    item_category2: item.product.sub_category_name,
    item_list_id: 'cart_recommendation',
    item_list_name: itemListName,
    item_variant: item.product.type || '',
    price: item.product.prices?.[0]?.price || 0,
  }));
};
